import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { Tooltip } from "react-tooltip";
import { IReservationV2 } from "../../interfaces/reservations/Reservations.types";
import { generateJourneyReservationPdf } from "../../services/Reservations.service";
import DeleteModal from "../ui/DeleteModal";
import IconBtn from "../ui/IconBtn";

interface UsersInfoProps {
  clientNames?: IReservationV2["clientNames"];
  journeyGuid: IReservationV2["journeyGuid"];
  paymentStatus: IReservationV2["paymentStatus"];
  uniqueJourneyId?: IReservationV2["uniqueJourneyId"];
  canUpdate?: boolean;
}

const UsersInfo: FC<UsersInfoProps> = ({
  clientNames,
  journeyGuid,
  paymentStatus,
  uniqueJourneyId,
  canUpdate
}) => {
  return (
    <div className="flex flex-col col-start-1 col-span-4">
      <div className="text-sm flex items-center gap-1">
        {uniqueJourneyId && <span className="text-xs mr-1 text-neutral">ID: </span>}
        {paymentStatus !== 2 && paymentStatus !== 5 ? (
          <>
            <a
              href={`${process.env.REACT_APP_CDN_API_URL}/journeyreservationdata/
            ${journeyGuid}/${uniqueJourneyId}.pdf`.replace(/\s/g, "")}
              target="_blank"
              className="group"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <span
                className="duration-300 text-opacity-90 group-hover:text-opacity-100
                         relative justify-center items-center
                         before:bg-primary before:absolute before:w-full before:h-[1px]
                         before:rounded-sm
                         before:bottom-0 before:left-0 before:origin-left
                         before:scale-x-0
                         before:duration-300 before:ease-in-out before:transform
                         group-hover:before:origin-left
                         group-hover:before:scale-x-100 transition-all text-primary"
              >
                {uniqueJourneyId}
              </span>
            </a>
            {/* PDF Regeneration Button */}
            {canUpdate && paymentStatus === 1 && uniqueJourneyId && (
              <span onClick={(e) => e.stopPropagation()}>
                <DeleteModal
                  params={uniqueJourneyId}
                  title="Konfirmo ri-gjenerimin e PDF-it"
                  paragraph="Ky veprim do të ri-gjenerojë PDF-in e biletës."
                  handleDelete={generateJourneyReservationPdf}
                  successMessage="PDF-i u ri-gjenerua me sukses"
                  errorMessage="Ndodhi një gabim gjatë ri-gjenerimit të PDF-it"
                  loadingMessage="Duke ri-gjeneruar PDF-in..."
                  indicator={
                    <IconBtn className="w-6 h-6 bg-gray-100 hover:bg-gray-200">
                      <div
                        data-tooltip-content="Ri-gjenero PDF-in e biletës"
                        data-tooltip-id={`regeneratePdf-${uniqueJourneyId}`}
                      >
                        <DocumentArrowDownIcon className="w-4 h-4 text-green-500 hover:text-green-600" />
                      </div>
                      <Tooltip id={`regeneratePdf-${uniqueJourneyId}`} className="z-50" />
                    </IconBtn>
                  }
                />
              </span>
            )}
          </>
        ) : (
          uniqueJourneyId
        )}
      </div>
      {clientNames ? (
        <>
          <div className="flex items-center">
            <p className="text-sm">
              {clientNames[0].firstName} {clientNames[0].lastName}
            </p>
          </div>
          <div className="flex items-center">
            <p className="text-sm font-light">{clientNames[0].email}</p>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default UsersInfo;
